// src/api/inventory.js
import { get, post, put } from "./api";

export const createInward = (payload) =>
  post("/inventory/inward", payload).then((r) => r);
export const getInwardById = (id) =>
  get(`/inventory/inward/${id}`).then((r) => r);
export const getInwardReceipts = (params) =>
  get(`/inventory/inward-receipts`, params).then((r) => r);

export const fetchSuppliers = () => get("/suppliers"); // filtered by req.user on server
export const fetchWarehouses = () => get("/warehouses"); // filtered by req.user on server
export const fetchProducts = () => get("/products"); // must include id, sku, name, case_pack_qty

export const getInventory = (params) =>
  get(`/inventory`, { params }).then((r) => r);

export const updateInventory = (id, data) =>
  put(`/inventory/${id}`, data).then((r) => r); 